export default "__VITE_ASSET__D9GVecz4__"